import { getIn, setIn } from "formik";
import { editSolutionFormSchema } from "../../../../edit/form/schema";
import type { EditSolutionFormValues } from "../../../../edit/form/types";
import { ValidationError } from "yup";

export const validateSection = async (values: EditSolutionFormValues) => {
  try {
    await editSolutionFormSchema.validate(values, { abortEarly: false });
    return {};
  } catch (error) {
    if (!(error instanceof ValidationError)) throw error;
    return error.inner.reduce<Record<string, unknown>>((errors, issue) => {
      if (!issue.path || getIn(errors, issue.path)) return errors;
      return setIn(errors, issue.path, issue.message) as Record<
        string,
        unknown
      >;
    }, {});
  }
};

export const getValidationIssues = (errors: unknown): string[] => {
  const issues: string[] = [];
  const collect = (value: unknown, path: string) => {
    if (typeof value === "string") {
      const label = path
        .replace(/\[(\d+)\]/g, " item $1")
        .replace(/[._-]/g, " ")
        .trim();
      issues.push(`${label}: ${value}`);
      return;
    }
    if (!value || typeof value !== "object") return;
    Object.entries(value).forEach(([key, nestedValue]) =>
      collect(nestedValue, path ? `${path}.${key}` : key),
    );
  };
  collect(errors, "");
  return issues;
};
